import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { UserWithPermissions } from '@interfaces/users.interface';

import { RootState } from '../store';

interface AuthState {
  user: UserWithPermissions | null;
  isLoading: boolean; // Used for page reload or first access
}

const slice = createSlice({
  name: 'auth',
  initialState: { user: null, isLoading: true } as AuthState,
  reducers: {
    setCredentials: (
      state,
      { payload }: PayloadAction<UserWithPermissions>,
    ) => {
      state.user = payload;
      state.isLoading = false;
    },
    stopLoading: (state) => {
      state.isLoading = false;
    },
    logout: (state) => {
      state.user = null;
    },
  },
});

export const { setCredentials, logout, stopLoading } = slice.actions;
export const selectCurrentUser = (state: RootState) => state.auth.user;
export const selectIsLoadingAuthState = (state: RootState) =>
  state.auth.isLoading;

export default slice.reducer;
